import { render, staticRenderFns } from "./config1Empresa.vue?vue&type=template&id=e3a8c938&scoped=true"
import script from "./config1Empresa.vue?vue&type=script&lang=js"
export * from "./config1Empresa.vue?vue&type=script&lang=js"
import style0 from "./config1Empresa.vue?vue&type=style&index=0&id=e3a8c938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a8c938",
  null
  
)

export default component.exports